import 'rc-slider/assets/index.css';
import React, { PureComponent } from 'react';
import Slider from 'rc-slider';
import PropTypes from 'prop-types';

export default class SliderTheme extends PureComponent {
  static propTypes = {
    marks: PropTypes.object,
    value: PropTypes.number,
    // min: PropTypes.number.isRequired,
    // max: PropTypes.number.isRequired,
    tipFormatter: PropTypes.func
  };

  state = {
    value: this.props.defaultValue
  }

  render() {
    const low = '#5B9EAA'
    const medium = '#F2911B'
    const high = '#F24B59'
    const { value } = this.state

    return (
      <div className='slider'>
        <div className='slider__min'>
          <p>{this.props.tipFormatter ? this.props.tipFormatter(this.props.min) : this.props.min}</p>
        </div>
        <div className='slider__max'>
          <p>{this.props.tipFormatter ? this.props.tipFormatter(this.props.max) : this.props.max}</p>
        </div>
        <Slider step={this.props.step} min={this.props.min} max={this.props.max} defaultValue={this.props.defaultValue }
          onChange={value => {
            this.props.onChange(value)
            this.setState({ value })
          }}
           marks={this.props.marks} tipFormatter={this.props.tipFormatter}
          handleStyle={
            value === 10 ? { backgroundColor: low } 
            : value === 55 ? { backgroundColor: medium } 
            : value === 100 ? { backgroundColor: high } 
            : {}}
            
          trackStyle={
            value === 10 ? { backgroundColor: low } 
            : value === 55 ? { backgroundColor: medium } 
            : value === 100 ? { backgroundColor: high } 
            : {}
          }/>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Slider.js